/**
 * Types of TcDataProvider
 */
export enum TcDataProviderType {
  BreezeJs = 'breezeJSDataSet',
  RestApi = 'restApi',
}
